import { isNil } from 'lodash';
import { validateSource, styleValidatorFactory, validateVersion, validateWmsFormat } from './validators';
import { trafficFlowStyleMappings, trafficIncidentsStyleMappings, mapStyleMappings } from './styleMappings';
import ThemeWrapper from './themeWrapper';
const schemaRegexp = /tomtom:\/\/([^/]+)\/([^/]+)\/?([^/]*)/;

export const schemaParserFactory = (layerAndStyleGetter, styleMappings) => {
    return (schemaUrl) => {
        const match = schemaUrl.match(schemaRegexp);

        if (!isNil(match) && match.length > 2) {
            const source = validateSource(match[1]);

            const version = validateVersion(match[2], source);
            const style = styleValidatorFactory(styleMappings)(source, match[3]);

            const [layer, styleName] = layerAndStyleGetter(style);

            const baseOptions = {
                source,
                style: styleName,
                layer
            };

            const options = version ? { ...baseOptions, version } : baseOptions;

            return new ThemeWrapper(ThemeWrapper.TYPE.RESOLVED_SCHEMA, options);
        }

        return new ThemeWrapper(ThemeWrapper.TYPE.URL, {
            url: schemaUrl
        });
    };
};

const parseStyleName = (styleName) => {
    return styleName.split('_');
};

export const mapStyleSchemaParser = (schemaUrl) => {
    const wmsMatch = schemaUrl.match(schemaRegexp);

    if (!isNil(wmsMatch) && wmsMatch[1] === 'wms' && wmsMatch.length > 2) {
        validateVersion(wmsMatch[2]);
        const format = validateWmsFormat(wmsMatch[3]);
        return new ThemeWrapper(ThemeWrapper.TYPE.RESOLVED_SCHEMA, {
            layer: 'wms',
            format: `image/${format}`,
            source: 'wms'
        });
    }

    return schemaParserFactory(parseStyleName, mapStyleMappings)(schemaUrl);
};

export const trafficFlowStyleSchemaParser = schemaParserFactory(
    (style) => ['flow', style],
    trafficFlowStyleMappings
);

export const trafficIncidentsStyleSchemaParser = schemaParserFactory(
    (style) => ['incidents', style],
    trafficIncidentsStyleMappings
);



// WEBPACK FOOTER //
// ./map/configurer/styleOptionInitialization/tierStyleSchemaParser.js